module.exports = __webpack_public_path__ + "static/media/th.62f0033c.svg";